<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop">▲ ページの先頭へ</a>
    <div class="max">
      <div class="company">
        <figure><img src="/images/common/logo.webp" alt="株式会社ゼンケイ"></figure>
        <dl>
          <dt>株式会社ゼンケイ</dt>
          <dd>〒151-0053 東京都渋谷区代々木2丁目5-5 新宿農協会館3階<br>TEL.03-3320-0086</dd>
        </dl>
      </div>
      <nav>
        <ul>
          <li itemprop="name"><a itemprop="url" href="/">TOP</a></li>
          <li itemprop="name"><a itemprop="url" href="/about/">ゼンケイについて</a></li>
          <li itemprop="name"><a itemprop="url" href="/solution/">ゼンケイの関わる世界</a></li>
          <li itemprop="name"><a itemprop="url" href="/company/">会社概要</a></li>
          <li itemprop="name"><a itemprop="url" href="/contact/">お問い合わせ</a></li>
          <li itemprop="name"><a itemprop="url" href="/news/">お知らせ</a></li>
          <li itemprop="name"><a itemprop="url" href="/privacy/">個人情報保護方針</a></li>
        </ul>
      </nav>
    </div>
    <small class="copy">Copyright &copy; {{ currentYear }} Zenkei All rights reserved.</small>
	</footer>
</template>

<style lang="scss" scoped>
footer{
  background: darken($gray, 4%);
  color: $normal;
  a{
    color: $normal;
  }
  .pagetop{
    background: darken($gray, 2%);
    display: block;
    text-align: center;
    padding: 1rem 0;
  }
  .max{
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: side2x();
    padding: 4.8rem side();
    @media screen and (max-width: $tab){
      padding: 4rem side();
      grid-template-columns: 1fr;
    }
  }
  .company{
    display: grid;
    grid-template-columns: 10.6rem 1fr;
    grid-gap: 2rem;
    @media screen and (max-width: $tab){
      grid-template-columns: 1fr;
    }
    figure{
      @media screen and (max-width: $tab){
        width: 16rem;
        margin: 0 auto;
      }
      img{
        opacity: .8;
        width: 100%;
        object-fit: cover;
      }
    }
    dl{
      line-height: 1.56;
      @media screen and (max-width: $tab){
        text-align: center;
      }
      dd{
        font-size: .72rem;
        margin: .4rem 0 0;
        @media screen and (max-width: $tab){
          font-size: 1rem;
        }
      }
    }
  }
  nav{
    ul{
      max-width: 34rem;
      margin: 0 0 0 auto;
      @include flex();
      justify-content: flex-end;
      align-items: flex-start;
      gap: .4rem;
      flex-wrap: wrap;
      @media screen and (max-width: $tab){
        max-width: 100%;
        margin: 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        align-items: center;
        justify-content: center;
        gap: .1rem;
      }
      li{
        margin: 0 0 0 1rem;
        @media screen and (max-width: $tab){
          margin: 0;
        }
        a{
          font-size: .92rem;
          @media screen and (max-width: $tab){
            background: $white;
            display: block;
            padding: 1rem;
          }
          &:hover{
            text-decoration: underline;
          }
        }
      }
    }
  }
  small{
    display: block;
    text-align: center;
    font-size: .72rem;
    border-top: rgba($normal,.08) .1rem solid;
    padding: 2.4rem 0;
  }
}
</style>

<script>
export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>